import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_HOST } from "environments/environment"

@Injectable({
    providedIn: 'root'
})
export class NewsletterApiService {

    constructor(private http: HttpClient) { }

    // =====================
    // Campaigns CRUD
    // =====================

    getCampaigns() {
        return this.http.get(API_HOST + 'admin/campaigns')
    }

    getCampaign(id: string) {
        return this.http.get(API_HOST + `admin/campaigns/${id}`)
    }

    createCampaign(data: any) {
        return this.http.post(API_HOST + 'admin/campaigns', data)
    }

    updateCampaign(id: string, data: any) {
        return this.http.put(API_HOST + `admin/campaigns/${id}`, data)
    }

    deleteCampaign(id: string) {
        return this.http.delete(API_HOST + `admin/campaigns/${id}`)
    }

    // =====================
    // Campaign Status
    // =====================

    updateCampaignStatus(id: string, status: string) {
        return this.http.post(API_HOST + `admin/campaigns/${id}/status`, { status })
    }

    // =====================
    // Recipients
    // =====================

    getFilteredUsers(filters: any) {
        return this.http.post(API_HOST + 'admin/campaigns/filter-users', filters)
    }

    assignRecipients(campaignId: string, filters: any) {
        return this.http.post(API_HOST + `admin/campaigns/${campaignId}/assign-recipients`, filters)
    }

    addTestRecipient(campaignId: string, email: string) {
        return this.http.post(API_HOST + `admin/campaigns/${campaignId}/add-test-recipient`, { email })
    }

    getRecipients(campaignId: string, page: number = 1, limit: number = 50, status?: string) {
        let url = `admin/campaigns/${campaignId}/recipients?page=${page}&limit=${limit}`;
        if (status) url += `&status=${status}`;
        return this.http.get(API_HOST + url)
    }

    // =====================
    // Copy with errors
    // =====================

    copyCampaignWithErrors(campaignId: string) {
        return this.http.post(API_HOST + `admin/campaigns/${campaignId}/copy-with-errors`, {})
    }

    // =====================
    // Test Email
    // =====================

    sendTestEmail(campaignId: string, email: string) {
        return this.http.post(API_HOST + `admin/campaigns/${campaignId}/send-test`, { email })
    }

    // =====================
    // Preview
    // =====================

    getPreview(htmlContent: string) {
        return this.http.post(API_HOST + 'admin/campaigns/preview', { htmlContent })
    }
}
